module.exports = __webpack_public_path__ + "media/images/avatar/08-59f4e2e608ccfcdb5d8f63b60a4c0069.jpg";